import { z } from 'zod';
import { CursorQuery } from './common/pagination.js';
import { PaymentSummary } from './payment.js';
/** Promotion / paid ads (FR-ADS-01…10, AC-ADS-01…06). Budget $100–$5,000 (FR-ADS-04). */
export const BUDGET_MIN_MINOR = 10_000;
export const BUDGET_MAX_MINOR = 500_000;
export const CtaLabel = z.enum([
    'none',
    'learn_more',
    'donate',
    'support',
    'join',
    'buy_tickets',
    'visit',
]);
/** Live estimate as the slider moves (FR-ADS-05, closes D-10: low→high, consistent magnitudes). */
export const PromotionEstimate = z.object({
    budgetMinor: z.number().int(),
    reachLow: z.number().int(),
    reachHigh: z.number().int(),
    clicksLow: z.number().int(),
    clicksHigh: z.number().int(),
    durationDays: z.number().int(),
    /** Bound to the same budget (closes D-11). */
    summary: PaymentSummary,
});
export const EstimateQuery = z.object({
    budgetMinor: z.coerce.number().int().min(BUDGET_MIN_MINOR).max(BUDGET_MAX_MINOR),
});
export const CreatePromotionInput = z.object({
    contentId: z.string(),
    budgetMinor: z.number().int().min(BUDGET_MIN_MINOR).max(BUDGET_MAX_MINOR),
    cta: CtaLabel.default('none'),
    methodId: z.string().optional(),
    idempotencyKey: z.string().min(8).max(100),
});
export const PromotionStatus = z.enum(['ongoing', 'completed', 'expired', 'cancelled']);
export const PromotionView = z.object({
    id: z.string(),
    contentId: z.string(),
    contentTitle: z.string(),
    status: PromotionStatus,
    cta: CtaLabel,
    budgetMinor: z.number().int(),
    spentMinor: z.number().int(),
    reach: z.number().int(),
    engagements: z.number().int(),
    startsAt: z.coerce.date(),
    endsAt: z.coerce.date(),
    paymentId: z.string(),
    createdAt: z.coerce.date(),
});
export const PromotionListQuery = CursorQuery.extend({
    status: PromotionStatus.optional(),
    q: z.string().trim().min(2).max(100).optional(),
});
//# sourceMappingURL=promotion.js.map